import React from 'react';
import styles from './JobseekerProfileEmployerViewBody.module.css';
import { useTranslation } from 'react-i18next';
import { CertificationLogo } from '../../../../assets/images/icons';
import moment from 'moment/moment';

function Certifications({ jobseeker, ref }) {
    const { t } = useTranslation();

    return (
        <div ref={ref} id='certifications' className={styles.educationContainer} style={{ width: '100%' }}>
            <h2 className={styles.heading}>{t('certifications.heading')}</h2>
            {jobseeker?.certification?.length > 0 ? (
                <div className={styles.certificationsListContainer}>
                    {jobseeker?.certification?.map((item) => {
                        return (
                            <div className={styles.certificationsContainer} key={item.id}>
                                <div className={styles.certificationsIcon}>
                                    <img
                                        className={styles.certificationsIconSVG}
                                        src={CertificationLogo}
                                        alt="Certification Logo"
                                    />
                                </div>
                                <div className={styles.certificationsBody}>
                                    <p className={styles.certificateHeading}>
                                        {item.certification_name}
                                    </p>
                                    <p className={styles.certificateDesc}>
                                        {`${t('certifications.issued_by')} ${item.issuing_organization}`}
                                    </p>
                                    <p className={styles.certificateDesc}>
                                        {t('certifications.earned', {
                                            date: moment(item.issue_date).format('MMMM YYYY'),
                                        })}
                                    </p>
                                </div>
                            </div>
                        );
                    })}
                </div>
            ) : (
                <p className={styles.description} style={{ marginTop: '15px' }}>
                    {t('certifications.no_certifications', 'The jobseeker has not completed any certifications.')}
                </p>
            )}
        </div>
    );
}

export default Certifications;
